
export const captionStyles = {
  color: '#2F5597',
  fontWeight: 'bold',
  textAlign: 'left',
  pl: 1,
  mt: 4,
  mb: 1,
}

export const footerStyles = {
  color: '#2F5597',
  fontWeight: 'bold',
  textAlign: 'left',
  backgroundColor: '#FFF2CC',
  width: '100%',
  position: 'sticky',
  left: 0,
  p: 0.5,
}
